import axios from 'axios'
import NProgress from 'nprogress'
import merge from 'lodash/merge'
import {
  Message
} from 'element-ui'

import errorCode from '@/utils/errorCode'
import { getAccessToken } from '@/utils/auth'

axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500 // 默认的
}

// 创建axios实例
const service = axios.create({
  timeout: 1000 * 30,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  },
  method: 'post'
})

service.adornUrl = (actionName) => {
  // 根据路径地址判断跳转到不同的项目地址
  return 'http://192.168.1.145:22443/jumper-form-api' + actionName
}

/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} openDefultParams 是否开启默认参数?
 */
service.adornParams = (params = {}, openDefultParams = true) => {
  var defaults = {
    't': new Date().getTime()
  }
  return openDefultParams ? merge(defaults, params) : params
}

/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} openDefultdata 是否开启默认数据?
 * @param {*} contentType 数据格式
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 */
service.adornData = (data = {}, openDefultdata = true, contentType = 'json') => {
  const thirdBaseUrl = sessionStorage.getItem('third_base_url') || '192.168.1.83:8088'
  var defaults = {
    'apiUrl': thirdBaseUrl,
    'token': sessionStorage.getItem('third_token'),
    't': new Date().getTime()
  }
  data = openDefultdata ? merge(defaults, data) : data
  return data
}
NProgress.configure({
  showSpinner: false
})
// request拦截器
service.interceptors.request.use(
  config => {
    NProgress.start()
    const isToken = (config.headers || {}).isToken === false
    const token = getAccessToken()
    if (token && !isToken) {
      config.headers['token'] = '807c380cf6998b99603c9c6cd3b7962d' // 请求头带上token
      config.headers['Authorization'] = 'Bearer ' + token // token
      // config.headers['Jwt'] = sessionStorage.getItem('jwt') // 请求头带上token
      // config.headers['Authorization'] = 'Bearer ' + sessionStorage.getItem('jwt')// 请求头带上token
    }

    return config
  },
  error => {
    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(res => {
  NProgress.done()
  // console.log(JSON.stringify(res))
  const status = Number(res.status) || 200
  const message = errorCode[status] || res.data.msg || errorCode['default']
  if (status === 401) {
    Message({
      message: message,
      type: 'error'
    })
    return Promise.reject(new Error(message))
  } else if (status === 500) {
    Message({
      message: message,
      type: 'error'
    })
    return Promise.reject(new Error(message))
  } else if (status !== 200 || res.data.code === 1) {
    Message({
      message: message,
      type: 'error'
    })
    return Promise.reject(new Error(message))
  } else {
    return res
  }
},
  error => {
    NProgress.done()
    return Promise.reject(new Error(error))
  }
)

export default service
